import * as React from 'react';
import { Skeleton } from '@mui/material';
import cn from 'classnames';

import { useTheme } from '../../../../../../theme';

interface Props {
	className?: string;
}

const CardExtraViewSkeleton: React.FC<Props> = ({ className }) => {
	const { CardExtraView: theme } = useTheme('Shared').CardExtraView;

	return (
		<div className={cn(theme.root, className)}>
			<Skeleton variant="rectangular" height={270} />
		</div>
	);
};

export default CardExtraViewSkeleton;
